import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MainLayout from '../../layouts/MainLayout';
import useFetch from '../../hooks/useFetch';

const CreateRoutine = () => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();

  const [routineCode, setRoutineCode] = useState('SANJEEV');
  const [entityCode, setEntityCode] = useState('THINK');
  const [className, setClassName] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [day, setDay] = useState('');
  const [subjects, setSubjects] = useState([{ subjectName: '', time: '' }]);

  const addSubject = () => setSubjects([...subjects, { subjectName: '', time: '' }]);

  const handleSubjectChange = (index, key, value) => {
    const updatedSubjects = [...subjects];
    updatedSubjects[index][key] = value;
    setSubjects(updatedSubjects);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      routineCode,
      entityCode,
      className,
      startDate,
      endDate,
      day,
      subjects,
      userId: authState.user._id,
    };

    const config = {
      url: '/routine/create',
      method: 'post',
      data: formData,
      headers: { Authorization: authState.token },
    };

    try {
      await fetchData(config);
      navigate('/dashboard'); 
    } catch (error) {
      console.error('Error creating routine:', error);
    }
  };

  return (
    <MainLayout>
      <div className="max-w-3xl mx-auto mt-12 p-6 bg-gray-600 shadow-lg rounded-lg">
        <h2 className="text-2xl font-semibold text-white mb-6">Create Classroom Routine</h2>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label htmlFor="routineCode" className="block text-sm font-medium text-white">
              Routine Code
            </label>
            <input
              id="routineCode"
              type="text"
              value={routineCode}
              onChange={(e) => setRoutineCode(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="entityCode" className="block text-sm font-medium text-white">
              Entity Code
            </label>
            <input
              id="entityCode"
              type="text"
              value={entityCode}
              onChange={(e) => setEntityCode(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="className" className="block text-sm font-medium text-white">
              Class Name
            </label>
            <input
              id="className"
              type="text"
              value={className}
              onChange={(e) => setClassName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-white">Routine Period</label>
            <div className="flex space-x-4">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Start Date"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="End Date"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div className="space-y-2">
            <label htmlFor="day" className="block text-sm font-medium text-white">
              Day
            </label>
            <input
              id="day"
              type="text"
              value={day}
              onChange={(e) => setDay(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            {subjects.map((subject, index) => (
              <div key={index} className="flex items-center space-x-4 mb-4">
                <input
                  type="text"
                  placeholder="Subject Name"
                  value={subject.subjectName}
                  onChange={(e) => handleSubjectChange(index, 'subjectName', e.target.value)}
                  className="flex-1 p-2 border border-gray-300 rounded-md"
                  required
                />
                <input
                  type="time"
                  value={subject.time}
                  onChange={(e) => handleSubjectChange(index, 'time', e.target.value)}
                  className="w-32 p-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
            ))}
            <button
              type="button"
              onClick={addSubject}
              className="mt-2 text-sm text-white hover:underline"
            >
              + Add Subject
            </button>
          </div>
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Create Routine
          </button>
        </form>
      </div>
    </MainLayout>
  );
};

export default CreateRoutine;
